import { apiService } from "@/services";
import { useQuery } from "@tanstack/react-query";
import { BrandCountry } from "@/types";

export const useGetCountries = () =>
  useQuery<BrandCountry[]>({
    queryKey: ["countries"],
    queryFn: () => apiService.get("/countries"),
    staleTime: Infinity,
  });
